export const ConfirmForm = ({
  username,
  password,
  isLoading,
  isError,
  setUsername,
  setPassword,
  handleActions,
}) => {
  return (
    <div className="row justify-content-center w-100">
      <div className="col-md-6">
        <form onSubmit={handleActions} method="POST">
          <div className="mb-3">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <input
              type="text"
              className="form-control"
              id="username"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              autoComplete="off"
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              autoComplete="off"
              required
            />
          </div>
          {isError && !isLoading && (
            <span className="text-danger">Invalid username or password!</span>
          )}
          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary w-100"
          >
            {isLoading ? (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};
